import React, { Component, Fragment } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

// Admin
import AdminUsersManager from "./adminUsersManager";
import AdminDocsManager from "./adminDocsManager";
import AdminFieldsManager from "./adminFieldsManager";
import AdminSpecificUserManager from "./adminSpecificUserManager/adminSpecificUserManager";
import AdminAssignmentsManager from "./adminAssignmentsManager";
import AdminPendingUsersManager from "./pendingUsers/adminPendingUsersManager";
import OpenSupportCasesManager from "./openSupportCasesManager";
import AdminNav from "./adminNav";
import "../../assets/css/admin.css";
import EndingMemberships from "./endingMemberships";
import TrackingEmployees from "./trackingEmployees";
import AdminVideosContainer from "./adminVideosContainer";
import AdminProductStates from "./adminProductStates";

class AdminContainer extends Component {
  render() {
    return (
      <Fragment>
        <BrowserRouter>
          <AdminNav />
          <div className="mt-20">
            <Switch>
              {/* Admin */}
              <Route exact path="/admin/users-manager/:givenSearchKey?" component={AdminUsersManager} />
              <Route exact path="/admin/docs-manager" component={AdminDocsManager} />
              <Route exact path="/admin/fields-manager" component={AdminFieldsManager} />
              <Route exact path="/admin/specific-user/:userId" component={AdminSpecificUserManager} />
              <Route exact path="/admin/assignments" component={AdminAssignmentsManager} />
              <Route exact path="/admin/pending-users" component={AdminPendingUsersManager} />
              <Route exact path="/admin/support" component={OpenSupportCasesManager} />
              <Route exact path="/admin/ending-memberships" component={EndingMemberships} />
              <Route exact path="/admin/upload-videos" component={AdminVideosContainer} />
              <Route exact path="/admin/track-employees" component={TrackingEmployees} />
              <Route exact path="/admin/product-states" component={AdminProductStates} />
            </Switch>
          </div>
        </BrowserRouter>
      </Fragment>
    );
  }
}

export default AdminContainer;
